// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Meta from 'vue-meta'
import axios from 'axios'
import apiConfig from '../config/api.config.js'

Vue.prototype.axios = axios;
axios.defaults.baseURL=apiConfig.baseURL

// Vue.prototype.$host = "http://localhost:10001"
Vue.prototype.$host = "http://admin.wzyangyu.com"
// Vue.prototype.$host = "/api"
Vue.config.productionTip = false
Vue.use(Meta)

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js